import { useTranslation } from 'react-i18next';
import { Container, UserWrapper, Name, NameWrapper } from './ProfileModalStyles';
import { COLORS } from '@/styles/colorTheme';
import lang from '@/assets/lang.svg';
import { useNavigate } from 'react-router-dom';
import { Settings, LogOut } from 'lucide-react';
import LanguageSetting from '@/ui/languageSetting';

interface ProfileModalProps {
  name?: string;
  plan?: string;
  email?: string;
  isVisible?: boolean;
  close?: () => void;
  sx?: React.CSSProperties;
}

export const ProfileModal = ({
  name,
  plan,
  email,
  isVisible = false,
  close,
  sx,
}: ProfileModalProps) => {
  const [t] = useTranslation('mainframe');
  const navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('state');
    window.location.href = '/signin';
  };

  return (
    <Container visible={isVisible} style={{ ...sx }}>
      <UserWrapper>
        <NameWrapper>
          <Name>
            <div className="text-xl font-semibold text-text-400">{name}</div>
          </Name>
          <div className="rounded bg-muted px-2 py-1 text-sm text-text-400">
            {plan?.charAt(0).toUpperCase() + plan?.slice(1)}
          </div>
        </NameWrapper>
        <div className="text-sm text-text-300">{email}</div>
      </UserWrapper>

      <div
        className="flex items-center gap-2 px-5 py-3 cursor-pointer hover:bg-muted"
        onClick={() => {
          navigate('/settings');
          close();
        }}
      >
        <Settings size={16} strokeWidth={1.5} />
        <div className="text-sm text-text-400">{t('Account Settings')}</div>
      </div>
      <div className="flex items-center justify-between gap-2 px-5 py-3">
        <div className="flex items-center gap-2">
          <img src={lang} alt="lang" className="w-4" />
          <span className="text-sm text-text-400">{t('Language')}</span>
        </div>
        <LanguageSetting />
      </div>
      <div
        className="flex items-center gap-2 px-5 py-3 cursor-pointer hover:bg-muted"
        onClick={logout}
        style={{
          borderTop: `1px solid ${COLORS.Background300}`,
          borderRadius: '0 0 12px 12px',
        }}
      >
        <LogOut size={16} strokeWidth={1.5} />
        <div className="text-sm text-text-400">{t('Signout')}</div>
      </div>
    </Container>
  );
};

export default ProfileModal;
